<script setup lang="ts">
import TextField from '@/components/forms/TextField/TextField.vue';
import { ref } from 'vue';
import { mdiEye, mdiEyeOff } from '@mdi/js';

const show = ref(false);
</script>

<template>
  <TextField
    :type="show ? 'text' : 'password'"
    :appendInnerIcon="show ? mdiEyeOff : mdiEye"
    @click:appendInner="show = !show"
  />
</template>
